/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */
import { Component } from 'react';
import { OrderedMap } from 'immutable';
import memoize from 'transmute/memoize';
import * as RequestStatus from 'automation-ui-core/constants/RequestStatus';
import { getSubscriptionTypes } from 'automation-ui-action-features/subscriptions/subscriptionsApi';
import { jsx as _jsx } from "react/jsx-runtime";
const getMemoizedSubscriptionTypes = memoize(getSubscriptionTypes);

/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */

/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
const FetchSubscriptionTypesHOC = WrappedComponent => {
  return class FetchSubscriptionTypes extends Component {
    constructor(...args) {
      super(...args);
      this.state = {
        fetchSubscriptionTypesRequestStatus: RequestStatus.UNINITIALIZED,
        subscriptionTypes: OrderedMap()
      };
      this.handleReceivedOutputsSuccess = payload => {
        const subscriptionTypes = OrderedMap().withMutations(subscriptionType => {
          payload.forEach(type => subscriptionType = subscriptionType.set(type.id, type));
        });
        this.setState({
          subscriptionTypes,
          fetchSubscriptionTypesRequestStatus: RequestStatus.SUCCEEDED
        });
      };
    }
    componentDidMount() {
      this.fetchSubscriptionTypesIfNecessary();
    }
    fetchSubscriptionTypesIfNecessary() {
      const {
        fetchSubscriptionTypesRequestStatus
      } = this.state;
      if (fetchSubscriptionTypesRequestStatus === RequestStatus.UNINITIALIZED) {
        this.setState({
          fetchSubscriptionTypesRequestStatus: RequestStatus.PENDING
        }, () => {
          getMemoizedSubscriptionTypes().then(this.handleReceivedOutputsSuccess, () => {
            this.setState({
              fetchSubscriptionTypesRequestStatus: RequestStatus.FAILED
            });
          });
        });
      }
    }
    render() {
      const {
        fetchSubscriptionTypesRequestStatus,
        subscriptionTypes
      } = this.state;
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        fetchSubscriptionTypesRequestStatus: fetchSubscriptionTypesRequestStatus,
        subscriptionTypes: subscriptionTypes
      }));
    }
  };
};
export default FetchSubscriptionTypesHOC;